import Icon from "@mui/material/Icon";
import { logout } from "../utils/utils";
import AppRoutes from "./routes";
import { styled } from "@mui/material/styles";

const ListIconStyle = styled(Icon)({
  fontSize: "1.7rem !important",
});

const getIcon = (name) => <ListIconStyle children={name} />;

const navConfig = [
  {
    title: "Contents",
    path: `${AppRoutes.dashboard}/${AppRoutes.contents}`,
    icon: getIcon("dashboard"),
  },
  {
    title: "Channels",
    path: `${AppRoutes.dashboard}/${AppRoutes.channels}`,
    icon: getIcon("playlist_play"),
  },
  {
    title: "Games",
    path: `${AppRoutes.dashboard}/${AppRoutes.games}`,
    icon: getIcon("sports_esports"),
  },
  {
    title: "Accounts",
    path: `${AppRoutes.dashboard}/${AppRoutes.users}`,
    icon: getIcon("group"),
  },
  {
    title: "Settings",
    path: `${AppRoutes.dashboard}/${AppRoutes.appSettings}`,
    icon: getIcon("app_settings_alt"),
  },
  {
    title: "Analytics",
    path: `${AppRoutes.dashboard}/${AppRoutes.analytics}`,
    icon: getIcon("analytics"),
  },
  {
    title: "Notifications",
    path: `${AppRoutes.dashboard}/${AppRoutes.notifications}`,
    icon: getIcon("notification_add"),
  },
  {
    title: "Payments",
    path: `${AppRoutes.dashboard}/${AppRoutes.payments}`,
    icon: getIcon("receipt_long"),
  },
  {
    title: "Reset Password",
    path: `${AppRoutes.dashboard}/${AppRoutes.password}`,
    icon: getIcon("lock_reset"),
  },
  {
    title: "Logout",
    path: ``,
    icon: getIcon("logout"),
    action: () => logout(),
  },
];

export default navConfig.filter(nav => nav !== null);
